const state = {
    MockCompanyID:null,
    companies:[],
    expandAll: false
}

export default state
